// src/components/Dashboard/hooks/useWorkspacesMetadata.js
import { useState, useEffect, useCallback, useRef } from 'react';
import { dedupeFetch } from '../../../apiRequestCache';

export const useWorkspacesMetadata = (userId, apiUrl) => {
  const [workspacesMetadata, setWorkspacesMetadata] = useState([]);
  const [loadingWorkspacesMeta, setLoadingWorkspacesMeta] = useState(false);
  const [error, setError] = useState(null);

  // Guard against duplicate in-flight requests (e.g. StrictMode double-invoked
  // mount effects). Only one request is issued at a time for a given user.
  const inFlightRef = useRef(false);

  const refreshWorkspacesMetadata = useCallback(async () => {
    if (!userId) return;
    if (inFlightRef.current) return;
    inFlightRef.current = true;
    setLoadingWorkspacesMeta(true);
    setError(null);
    try {
      const data = await dedupeFetch(`${apiUrl}/SiteNote/GetStackedWorkspaces?pageNumber=1&pageSize=10000&userId=${userId}`);
      setWorkspacesMetadata(data.workspaces || []);
    } catch (err) {
      console.error('Error fetching workspace metadata:', err);
      setError(err.message);
    } finally {
      setLoadingWorkspacesMeta(false);
      inFlightRef.current = false;
    }
  }, [apiUrl, userId]);

  // Initial fetch
  useEffect(() => {
    refreshWorkspacesMetadata();
  }, [refreshWorkspacesMetadata]);

  return {
    workspacesMetadata,
    loadingWorkspacesMeta,
    error,
    refreshWorkspacesMetadata,
  };
};